export const ABOUT_SECTION_LINKS = [
  { label: "STORIES", href: "/stories" },
  { label: "PHOTOGRAPHY", href: "/photography" },
  { label: "VIDEO", href: "/videos" },
  { label: "PROJECTS", href: "/projects" },
  { label: "BLOG", href: "/blog" },
];

export const ABOUT_HERO = {
  eyebrow: "ABOUT · CJ JAYAMAHA",
  title: "Product leader, photographer, filmmaker, adventurer & storyteller.",
  imageKey: "cjmeister-com-_DSC2190.jpg",
};

export const ABOUT_IMAGES = {
  break: "cjmeister-com-06076.jpg",
  wildlifeLeft: "cjmeister-com-_CJ09300.jpg",
  wildlifeRight: "rhino-hero.jpg",
};

export const ABOUT_PILLARS = [
  {
    label: "Product & technology",
    text: "Two decades building products, leading teams, and turning complex ideas into things people use.",
  },
  {
    label: "Photography & film",
    text: "Documenting wildlife, travel, motorsport, and the quiet moments that sit between the big adventures.",
  },
  {
    label: "Exploration",
    text: "Motorcycles, mountains, unfamiliar roads, and conversations with strangers who become part of the story.",
  },
];

export const ABOUT_PROSE = {
  openingLead:
    "For more than two decades, I've worked at the intersection of technology, people, and ideas — helping companies build products, lead teams, and solve complex problems. My career has taken me through startups, global corporations, digital transformation programmes, and entrepreneurial ventures, giving me the opportunity to work across industries, cultures, and continents.",
  openingStatement: "But work is only part of the story.",
  exploration:
    "Outside of technology, I have always been drawn to exploration. Sometimes that means riding a motorcycle across remote landscapes, hiking through unfamiliar terrain, travelling to places with remarkable stories, or simply spending time with people whose experiences offer a different perspective on the world.",
  photographyLine: "Photography and filmmaking became a natural extension of that curiosity.",
  afterBreak:
    "Through a camera, I document places, people, wildlife, adventures, and everyday moments that might otherwise be overlooked. Some stories unfold over thousands of kilometres of travel. Others happen in a single conversation. What interests me is not just what we see, but the stories behind it.",
  websiteIntro:
    "This website brings together many of the things that shape my life: technology projects, photography, films, adventures, personal reflections, and the experiences gathered along the way.",
  quote:
    "It is not a portfolio in the traditional sense. It is a collection of journeys, observations, lessons, and stories.",
  closing:
    "Whether you've arrived here because of my professional work, my photography, my videos, or a shared interest in adventure and exploration, I hope you find something that inspires curiosity, sparks a conversation, or encourages you to see the world a little differently.",
  breakCaption:
    "SOME STORIES UNFOLD OVER THOUSANDS OF KILOMETRES. OTHERS HAPPEN IN A SINGLE MOMENT.",
};

export const ABOUT_META = {
  title: "About CJ Jayamaha",
  description:
    "Product leader, photographer, filmmaker, adventurer and storyteller. The story behind cj.photos — journeys, observations, lessons, and the work that shapes them.",
  path: "/about",
  imageKey: ABOUT_HERO.imageKey,
};
